export default "__VITE_PUBLIC_ASSET__eae48392__"